import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  connection: null,
  connectionId: '',
}

const SignalRSlice = createSlice({
  name: 'signalR',
  initialState,
  reducers: {
    setConnection: (state, action) => {
      state.connection = action.payload.connection
      state.connectionId = action.payload.connectionId
    },
  },
})

export const { setConnection } = SignalRSlice.actions
export default SignalRSlice.reducer
